module.exports = __webpack_public_path__ + "assets/img/mecha-btn-22402dac.png";